import { createFileRoute, Outlet } from '@tanstack/react-router'
import { NavBar } from '@/components/NavBar'
import { Footer } from '@/components/Footer'
import { Analytics } from '@/components/Analytics'
import { usePageMeta } from '@/lib/use-document-meta'

export const Route = createFileRoute('/_layout')({
  component: LayoutComponent,
})

function LayoutComponent() {
  // Derives <head> meta from PAGE_META by current path for every content child.
  usePageMeta()
  return (
    <div className="flex min-h-screen flex-col bg-surface-0">
      <NavBar />
      <Analytics />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
